// BEE-20: Testimonial section
import type { CSSProperties } from 'react'

const AVATAR_STYLE: CSSProperties = {
  background: 'linear-gradient(135deg, #f7d7b6 0%, #c4894e 100%)',
}

export default function Testimonial() {
  return (
    <section className="py-10 sm:py-14 px-6">
      <div className="max-w-[620px] mx-auto">
        <div className="bg-[#faf3e0] border border-[#f0dfa6] rounded-[24px] p-10">

          {/* Quote */}
          <blockquote className="font-serif italic font-medium text-[23px] leading-[1.4] text-[#3a2c0c] mb-7 tracking-[-0.005em]">
            "When Mom broke her hip, we were overwhelmed. KindredCanopy gave us a place to coordinate
            everyone who wanted to help. It turned chaos into a system — and reminded us we weren't
            doing this alone."
          </blockquote>

          {/* Author */}
          <div className="flex items-center gap-3">
            {/* Avatar */}
            <div
              style={AVATAR_STYLE}
              className="w-10 h-10 rounded-full flex items-center justify-center font-serif font-semibold text-[16px] text-[#8a4a1f] flex-none"
              aria-hidden="true"
            >
              M
            </div>
            <div>
              <div className="font-sans font-semibold text-[14px] text-[#3a2c0c]">
                Maya Chen-Walker
              </div>
              <div className="font-sans text-[13px] text-[#8a6a25]">
                Daughter · Portland, OR
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}
